var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RPFilter',{ref:"button",staticClass:"RPDateFilter",attrs:{"dropdown-position":"left"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var open = ref.open;
return [_c('div',{class:[
                'RPDateFilter__tag',
                open && 'RPDateFilter__tag--open'
            ]},[_c('StreamlineIcon',{staticClass:"RPDateFilter__tag-icon",attrs:{"icon":_vm.Calendar,"size":12,"stroke":open ? _vm.primary : _vm.grey}}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)]}},{key:"dropdown",fn:function(ref){
            var isModal = ref.isModal;
            var close = ref.close;
return [_c('DateFilterDropdown',{attrs:{"current-dates":_vm.value,"options":_vm.options,"calendar-options":_vm.calendarOptions,"is-modal":isModal,"single-date":_vm.singleDate},on:{"close":close,"select":function (s) { return _vm.select(s, close); }}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }